import styled from "styled-components";

export const TitleFaturaTextValue = styled.span`
  color: #000;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 20px;
  width: 50%;

  @media print {
    font-size: 9pt;
  }
`;

export const SpanTextTitleBold = styled.span`
  color: #000;
  font-weight: bold;
  font-size: 14px;

  @media print {
    font-size: 8pt;
  }
`;

export const SpanTextTitle = styled.span`
  color: #000;
  font-size: 14px;

  @media print {
    font-size: 9pt;
  }
`;

export const Dividers = styled.hr`
  border-top: 1px dashed #7c7c7c;
  width: 100%;
  height: 1px;

  @media print {
    border-top: 1px solid #000;
  }
`;

export const SpanTextValue = styled.span`
  color: #000;
  font-size: 12px;
  font-weight: 600;
  width: 90px;
  text-align: end;
  padding-right: 1%;

  @media print {
    font-size: 7pt;
  }
`;